import React from 'react'

export const ExpiredNotice = () => {
  return (
    <div className="expired-notice">
      <p>¡LLEGÓ EL MUNDIAL CELÉBRALO CURRAMBA!</p>
    </div>
  );
};

